export default __webpack_public_path__ + "static/media/onyx-min.05b2875e.png";